var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"read-only-banner",attrs:{"role":"status"}},[_vm._v(" Maintenance on Monday 26 October from 16:00 to about 17:00 (UK time): the CMS is read-only. You can view everything, but changes can't be saved during that time. ")])}
var staticRenderFns = []

export { render, staticRenderFns }